import { autoinject, transient, useView } from "aurelia-framework";
import { EntityTypeConfigurationHelper, EntityTypeConfigurationModel } from "../../../../../../models/basics/basics.models";
import { ManageVesselService } from "../../../../../../services/vessels/manage-vessel.service";
import { IOrderMetaPlugin, OrderModel } from "../../../../../../models/rightstore/rightstore.models";
import { ValidationActivation, ValidationTypeEnum } from "../../../../../../client-validation-system/validations.models";
import { ClientSideValidator, EntityValidationsService } from "../../../../../../client-validation-system/validations-service";
import { VesselComparisonItem } from "./models/vessel-comparison-item";

@autoinject()
@transient()
@useView('views/pages/modules/orders/plugins/vessel-comparison-pdf/vessel-comparison-pdf.html')
export class VesselComparisonPdf implements IOrderMetaPlugin {

    private vesselItems: VesselComparisonItem[] = [];
    public vesselEntityTypeConfigurationModel: EntityTypeConfigurationModel[];
    public order: OrderModel;
    public viewTitle: string;
    public disableSubmit: boolean;
    public canSubmit: boolean = true;
    public validator: ClientSideValidator;

    constructor(protected vesselService: ManageVesselService,
        private entityValidationsService: EntityValidationsService,
        private entityTypeConfigurationHelper: EntityTypeConfigurationHelper) {

        this.vesselEntityTypeConfigurationModel = this.entityTypeConfigurationHelper.getConfigurationByKey(["AllVesselSearch"]).filter(x => x.key == "AllVesselSearch");

        //Add two vessels to the list if empty
        if (this.vesselItems.length == 0) {
            this.vesselItems.push(new VesselComparisonItem());
            this.vesselItems.push(new VesselComparisonItem());
        }
    }

    async activate(params: { order: OrderModel }) {
        this.order = params.order;
        this.viewTitle = this.order.product.name;
    }

    removeVessel(index: number) {
        this.vesselItems.splice(index, 1);
    }

    addAnotherVessel() {
        if (this.vesselItems.length < 4) {
            this.vesselItems.push(new VesselComparisonItem());
        }
    }

    private setValidator() {
        const rules = {
            activation: ValidationActivation.Always,
            entityName: "vesselItems",
            isCollection: true,
            nestedRulesHolder: [],
            rules: [{
                errorMessage: "Vessel is required",
                parameters: null, property: "id",
                validationType: ValidationTypeEnum.Required
            }]
        }

        this.validator = this.entityValidationsService.getValidator(this.vesselItems, rules);
    }

    public async isValid(): Promise<boolean> {
        this.setValidator();
        const isValid = await this.validator.validate();

        if (!isValid) {
            return false;
        }

        if (this.vesselItems.length < 2 || this.vesselItems.length > 4 || this.vesselItems.filter(x => x.vessel == null || x == null).length > 0) {
            return false;
        }

        return true;
    }

    public getMetaModel() {
        const vesselIds = this.vesselItems.filter(x => x != null).map(x => x.vessel.id);
        const metaModel = {
            vesselIds: vesselIds
        };
        return metaModel;
    }
}